export default "__VITE_ASSET__65ae93EM__"